import Dialog from 'components/Dialog';
import React, { useState } from 'react';
import config from 'config';

export const useContactDialog = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const renderDialog = () => (
    <Dialog
      open={open}
      hideActions
      showFloatingCancel
      onClose={handleClose}
      title="Contact Us"
    >
      <p style={{ lineHeight: '1.5em' }}>
        <span style={{ color: 'rgb(3, 79, 125)' }}>Have questions or need some assistance?</span>
        {' '}Contact us using any of the methods below and we will get back to you as soon as we can.
      </p>

      <p style={{
        marginTop: 0,
        fontWeight: 600,
        fontSize: '0.875em',
        marginBottom: '0.5em'
      }}>
        Contact
      </p>

      <table style={{
        width: '100%',
        borderWidth: '1px',
        marginBottom: '1em',
        borderStyle: 'solid',
        borderCollapse: 'collapse',
        borderColor: 'rgba(54, 88, 107, 0.13)'
      }}>
        <tbody>
          <tr style={{ borderStyle: 'solid', borderWidth: '0px', borderBottomWidth: '1px' }}>
            <td style={{ padding: '0.4em', backgroundColor: 'rgba(112, 147, 167, 0.13)', width: '30%', fontWeight: 600 }}>Email</td>
            <td style={{ padding: '0.4em', fontWeight: 300 }}>{config.contact.email}</td>
          </tr>
          <tr>
            <td style={{ padding: '0.4em', backgroundColor: 'rgba(112, 147, 167, 0.13)', width: '30%', fontWeight: 600 }}>Phone</td>
            <td style={{ padding: '0.4em', fontWeight: 300 }}>{config.contact.phone}</td>
          </tr>
        </tbody>
      </table>

    </Dialog>
  );

  return [renderDialog, setOpen];
};

export default useContactDialog;
